import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export interface Filter {
    categories?: number[];
    subCategory?: number;
}

export interface MentorState {
    filter: Filter
}

const initialState: MentorState = {
    filter: {}
}

export const mentorSlice = createSlice({
    name: 'mentor',
    initialState,
    reducers: {
        getFilters: (state) => {
            void state;
        },
        setFilters: (state, action: PayloadAction<Filter>) => {
            state.filter = action.payload
        }
    }
})

export const {
    getFilters,
    setFilters
} = mentorSlice.actions

export default mentorSlice.reducer
